import React from 'react'
import { Path } from 'react-native-svg'

import { createIcon } from '../../_gluestack/icon'

export const AircraftStandsIcon = createIcon({
    viewBox: '0 0 24 24',
    path: (
        <>
            <Path d='M20.5331 1H15.5331V2L17.5331 2V4H18.5331V2L20.5331 2V1Z' fill='currentColor' />
            <Path
                d='M11.1734 14.3019L6.97878 12.9714V15.9009L8.0337 16.7069V17.5L6.20015 16.9755L4.37915 17.5V16.7069L5.40895 15.9009V12.9714L1.2395 14.3019V13.2529L5.40895 10.5792V7.64973C5.40895 7.42799 5.48431 7.24037 5.63501 7.08686C5.78571 6.93334 5.97409 6.85659 6.20015 6.85659C6.4262 6.85659 6.61249 6.93334 6.759 7.08686C6.90552 7.24037 6.97878 7.42799 6.97878 7.64973V10.5792L11.1734 13.2529V14.3019Z'
                fill='currentColor'
            />
            <Path
                d='M23 14.3019L18.8054 12.9714V15.9009L19.8604 16.7069V17.5L18.0268 16.9755L16.2058 17.5V16.7069L17.2356 15.9009V12.9714L13.0662 14.3019V13.2529L17.2356 10.5792V7.64973C17.2356 7.42799 17.311 7.24037 17.4617 7.08686C17.6124 6.93334 17.8008 6.85659 18.0268 6.85659C18.2529 6.85659 18.4391 6.93334 18.5857 7.08686C18.7322 7.24037 18.8054 7.42799 18.8054 7.64973V10.5792L23 13.2529V14.3019Z'
                fill='currentColor'
            />
            <Path
                d='M18.5331 23H24V24H0V23H5.70642V20H6.70642V23H17.5331V20H18.5331V23Z'
                fill='currentColor'
            />
            <Path d='M8.70642 1H3.70642V2L5.70642 2V4H6.70642V2L8.70642 2V1Z' fill='currentColor' />
        </>
    ),
})

AircraftStandsIcon.displayName = 'AircraftStandsIcon'
